import React, { useState, useEffect } from "react";
import axios from "axios";
import ConfirmationDialog from "./modalPopup";

const API_URL = process.env.REACT_APP_API_URL;

export const SubscriptionDetails = ({ subscriptionData }) => {
  const [selectedSubscription, setSelectedSubscription] = useState(null);
  const [loading, setLoading] = useState(true);
  const autoRenewal = selectedSubscription?.subscriptions?.tipo === "recurring";

  useEffect(() => {
    console.log("SUBSCRIPTION DATA: ", subscriptionData);
    if (subscriptionData) {
      console.log("SUBSCRIPTION:", subscriptionData);
      setSelectedSubscription(subscriptionData);
      setLoading(false);
    } else {
      setLoading(false);
    }
  }, [subscriptionData]);

  const upgradeSubscription = () => {
    console.log("aggiorna");
  };

  if (loading) {
    return <div className="text-center text-xl">Loading...</div>;
  }

  if (!selectedSubscription) {
    console.log("NESSUN ABBONAMENTO");
    return (
      <div className="text-center text-xl">Nessun abbonamento selezionato</div>
    );
  }

  return (
    <div className="text-left">
      <span className="font-semibold ">Piano </span>
      <div className="grid grid-cols-2 gap-4">
        {subscriptionData.allSubscriptionTypes.map(
          (element, index) =>
            element.titolo != "Abbonamento digitale" &&
            (element.titolo === subscriptionData.product.titolo ? (
              <div
                key={index}
                className="grid grid-cols-2 p-4 bg-blue-100 border border-blue-500 rounded"
              >
                <p className="text-left overflow-hidden">
                  <span className="text-black font-semibold">
                    {element.titolo}
                  </span>
                </p>
                <p className="ml-10  text-center overflow-hidden ">
                  <span className="font-semibold">€{element.prezzo}</span>/anno
                </p>

                <p className="font-semibold">
                  <span className="text-gray-500 font-normal">Stato: </span>
                  {selectedSubscription.subscriptions.status}
                </p>
              </div>
            ) : (
              <div
                key={index}
                className="grid grid-cols-2 p-4 bg-white border border-gray-500 rounded"
              >
                <p className="text-left overflow-hidden">
                  <span className="text-black font-semibold">
                    {element.titolo}
                  </span>
                </p>
                <p className="ml-10  text-center overflow-hidden ">
                  <span className="font-semibold">€{element.prezzo}</span>
                  /anno
                </p>
                {/*
                <button
                  onClick={() => upgradeSubscription()}
                  className="col-span-2 bg-blue-500 py-2 text-white font-semibold rounded mt-4 w-auto max-w-52 outline-none hover:bg-blue-700 transition"
                >
                  Aggiorna abbonamento
                </button>
                */}
              </div>
            ))
        )}
      </div>

      <p className="text-left">
        <br />
        <span className="text-gray-500">Data Inizio: </span>
        {new Date(
          selectedSubscription.subscriptions.data_inizio
        ).toLocaleDateString()}
      </p>
      <p className="text-left">
        <span className="text-gray-500">Data Fine: </span>
        {new Date(
          selectedSubscription.subscriptions.data_fine
        ).toLocaleDateString()}
      </p>
      <p className="font-semibold">
        {selectedSubscription.differenzaGiorni}
        <span className="text-gray-500 font-normal"> giorni rimanenti</span>
      </p>

      <div className="w-full">
        <div className="flex items-center justify-between">
          <p className="font-semibold">Attiva rinnovo automatico</p>
          <ToggleButton autoRenewal={autoRenewal} />
        </div>
        <p className="text text-gray-500">
          Se attivi il rinnovo automatico, ti verrà addebitato automaticamente
          il prezzo dell'abbonamento alla data di scadenza.
        </p>
      </div>
      <br />
    </div>
  );
};

const ToggleButton = ({ autoRenewal }) => {
  const [isToggled, setIsToggled] = useState(autoRenewal);
  const [isDialogOpen, setIsDialogOpen] = useState(false);
  const [pendingToggle, setPendingToggle] = useState(false);
  const [loading, setLoading] = useState(false); // Add loading state
  const [error, setError] = useState(null); // Add error state

  useEffect(() => {
    // Ensure the state is in sync with the prop on the initial render and whenever autoRenewal changes
    setIsToggled(autoRenewal);
  }, [autoRenewal]);

  const handleToggle = async () => {
    setPendingToggle(!isToggled); // Set the pending toggle value opposite to current toggle state
    setIsDialogOpen(true); // Open the confirmation dialog
  };

  const confirmToggle = async () => {
    setLoading(true); // Start loading
    setError(null); // Reset any previous errors
    setIsDialogOpen(false); // Close the dialog

    try {
      await toggleSubscription(pendingToggle); // Call the API with the pending toggle value
      setIsToggled(pendingToggle); // If successful, apply the pending toggle value
    } catch (err) {
      console.error("Error toggling subscription:", err);
      setError("Failed to update the subscription. Please try again."); // Set error message
    } finally {
      setLoading(false); // End loading
    }
  };

  const toggleSubscription = async (autoRenew) => {
    try {
      const response = await axios.post(
        `${process.env.REACT_APP_API_URL}/toggleAutoRenew`,
        { autoRenew }
      );
      console.log("API response:", response);
    } catch (err) {
      throw err; // Re-throw the error to be caught in confirmToggle
    }
  };

  /*
  useEffect(() => {
    if (isToggled !== autoRenewal) {
      toggleSubscription(isToggled);
    }
  }, [isToggled]);*/

  return (
    <div className="flex justify-end p-4">
      <div
        onClick={handleToggle}
        className={`${
          isToggled ? "bg-blue-500" : "bg-gray-300"
        } relative w-14 h-8 rounded-full cursor-pointer transition-colors duration-300 ease-in-out `}
      >
        <div
          className={`${
            isToggled ? "translate-x-6" : "translate-x-0"
          } absolute top-1 left-1 w-6 h-6 bg-white rounded-full shadow-md transform transition-transform duration-300 ease-in-out`}
        ></div>
      </div>

      {/* Confirmation Dialog */}
      <ConfirmationDialog
        isOpen={isDialogOpen}
        onClose={() => setIsDialogOpen(false)}
        onConfirm={confirmToggle}
        title="Conferma Modifica"
        message={`Sei sicuro di voler ${
          pendingToggle ? "attivare" : "disattivare"
        } il rinnovo automatico?`}
        confirmLabel="Conferma"
        cancelLabel="Annulla"
        iconColor="text-blue-600"
        iconBgColor="bg-blue-100"
        confirmBgColor="bg-blue-500"
        confirmHoverBgColor="bg-blue-700"
      />
    </div>
  );
};

export default ToggleButton;
